export const getGrupos = (state) => state.grupos.lista
export const getIsSavingGrupos = (state) => state.grupos.isSaving
export const getIsCarregandoListaGrupos = (state) => state.grupos.isCarregandoLista
